import styled, { css } from 'styled-components';
import { DropdownItemProps } from './DropdownListItems.types';

export const DropdownItemContainer = styled.li<DropdownItemProps>`
  list-style-type: none;
  padding: var(--spacing-s) var(--spacing-m);
  border-radius: var(--radius-8);
  cursor: pointer;
  background: var(--color-interface-neutral-light);

  // Override style of Label and Checkbox component
  > p,
  > div > label > p {
    color: var(--color-interface-secondary-normal);
    white-space: nowrap;
  }

  &:hover,
  &:focus {
    background: var(--color-interface-layout-lighter);
  }

  &:active {
    background: var(--color-interface-layout-normal);
  }

  ${(p) =>
    p.topSticky &&
    css`
      position: sticky;
      top: 0;
    `}

  ${(p) =>
    p.bottomSticky &&
    css`
      position: sticky;
      bottom: 0;
    `}

  ${(p) =>
    p.selected &&
    css`
      background: var(--color-interface-layout-lighter);
    `}

  ${(p) =>
    p.disabled &&
    css`
      pointer-events: none;

      // Override style of Label and Checkbox component
      > p,
      > div > p {
        color: var(--color-interface-layout-darker);
      }
    `}
`;

export const DropdownItemConfirmationOptions = styled.div`
  display: flex;
  gap: var(--spacing-s);
`;
